import { produce } from 'immer';

export const wrapReducers = (actions, initialState) => (state = initialState, action) => {
  const { type: actionType, payload } = action;

  if (!(actionType in actions)) {
    return state;
  }

  return actions[actionType](state, payload, action);
};

// TODO: Package createCollectionReducer and createCollectionReducer into a single object
export const createCollectionReducer = (prefix, options = { initCurrentId: true }) => (state = { all: [], currentId: null }, action) => {
  const { scope, payload } = action;

  if (scope !== prefix) return state;

  switch (action.type) {
    case 'addCollection':
      return produce(state, (draft) => {
        draft.all = payload;
        if (draft.all.length > 0 && !draft.currentId && options.initCurrentId) {
          draft.currentId = draft.all[0].id;
        }
      });
    case 'setCurrentId':
      return produce(state, (draft) => { draft.currentId = payload; });
    default:
      return state;
  }
};

export const createCollectionClient = (dispatch, scope) => ({
  add: collection => dispatch({ type: 'addCollection', payload: collection, scope }),
  setId: id => dispatch({ type: 'setCurrentId', payload: id, scope }),
});
